export const API_URL = process.env.REACT_APP_API_URL || 'https://api.ligchat.com/api';
export const CONTACTS_API_URL = process.env.REACT_APP_WHATSAPP_API_URL || process.env.REACT_APP_CONTACTS_API_URL || 'https://whatsapp.ligchat.com/api/v1';
